import ADILiveChatComponent from "@NA/Components/ADILiveChatComponent";
import ADIColors from "@NA/Utils/ADIColors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { StyledButton } from "@insite/mobius/Clickable";
import LazyImage, { LazyImageStyle } from "@insite/mobius/LazyImage";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface ADILiveChatContactUsStyles {
    contactUsChatWithUsContainer?: InjectableCss;
    telephoneStyles?: InjectableCss;
    findYourBranchLink?: InjectableCss;
}

export const adiLiveChatContactUsStyles: ADILiveChatContactUsStyles = {
    contactUsChatWithUsContainer: {
        css: css`
        text-align: center;
        padding: 0px;
        background-color: ${ADIColors.gray6};
        border-radius: 0px 0px 4px 4px;
        @media only screen and (max-width: 700px) {
            margin-bottom: 20px;
        }
        >${LazyImageStyle}{
            margin: 0px;
            display: flex;
            > span {
                position: relative;
            }
        }
        >h1{
            font-weight: 700;
            margin: 20px 0px 5px 0px;
            line-height: 1.25em;
            color: ${ADIColors.darkBlue1};
            font-size: 24px;
            @media only screen and (max-width: 1080px) {
                font-size: 20px;
            }
        }
        `
    },
    telephoneStyles: {
        css: css`
        color: ${ADIColors.darkBlack2};
        font-weight: normal; 
        font-size: 14px;
        line-height: 1.6;
        >${StyledButton}{
            >${TypographyStyle}{
                color: ${ADIColors.blue5};
                &:hover{
                    color: ${ADIColors.blue1};
                    text-decoration: underline;
                }
            }
        }
        :last-child {
            margin-bottom: 10px
        }
        `
    },
    findYourBranchLink: {
        css: css`
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: center;
        padding: 12px 0px 24px 0px !important;
        >${StyledButton}{
            font-weight: 700;
            font-size: 14px;
            >${TypographyStyle}{
                &:hover{
                    color: ${ADIColors.blue1};
                    text-decoration: underline;
                }
            }
        }
        `
    },
};

const styles = adiLiveChatContactUsStyles;
const isPRRegion = typeof window !== 'undefined' && window.location.hostname.endsWith(".pr");

const ADILiveChatContactUs = ({ id }: Props) => {
    return (
        <StyledWrapper {...styles.contactUsChatWithUsContainer}>
            <LazyImage src={`https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/Promo/Q221451-customer-support.png`} />
            <Typography as="h1">{translate("Customer Support")}</Typography>
            <Typography as="p" {...styles.telephoneStyles}>{translate("Website Support:")} <Link href="tel:1.877.228.6739">{translate("1.877.228.6739")}</Link></Typography>
            <Typography as="p" {...styles.telephoneStyles}>{translate("Systems Design:")} <Link href="tel:1.800.234.7971">{translate("1.800.234.7971")}</Link></Typography>
            {!isPRRegion && <ADILiveChatComponent contactUsPage={true} />}
            <StyledWrapper {...styles.findYourBranchLink}>
                <Link href="/dealerlocator">{translate("Find Your Branch")}</Link>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: ADILiveChatContactUs,
    definition: {
        group: "Common",
        displayName: "ADI Live Chat Contact Us",
    },
};

export default widgetModule;

